var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.order)?_c('span',{staticClass:"status",class:'order-status-' + _vm.order.orderStatusId},[_vm._v(_vm._s(_vm.orderStatus))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }